
import type { UserModelView } from '../dto/userDto';
import type { ApiCommand, ApiRequest } from './apiCommand';
import { assumeHalCollection } from '../type-guards/assumeType';

export class ListUsersCommand implements ApiCommand<UserModelView[]> {
  constructor(input: Record<string, never>) {
    void input;
  }

  request(): ApiRequest {
    return {
      linkName: 'users',
      pathParams: {},
      queryParams: {},
      method: 'GET',
      body: null
    };
  }

  asOutput(body: unknown): UserModelView[] {
    return assumeHalCollection<UserModelView>(body);
  }
}
